import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '../../shared/shared.module';
import { AgGridModule } from 'ag-grid-angular';
import { LiftBySpotTileModule } from './lift-by-spot-tile/lift-by-spot-tile.module';
import { TrafficByAffiliateTileModule } from './traffic-by-affiliate-tile/traffic-by-affiliate-tile.module';
import { TrafficBySourceTileModule } from './traffic-by-source-tile/traffic-by-source-tile.module';
import { MicromomentTimelineTileModule } from './micromoment-timeline-tile/micromoment-timeline-tile.module';
import { TimeOfDayTileModule } from './time-of-day-tile/time-of-day-tile.module';
import { KwTileModule } from './kw-tile/kw-tile.module';
import { LiftBySpotFullModule } from './lift-by-spot-full/lift-by-spot-full.module';
import {MatNativeDateModule} from "@angular/material/core";
import {DemoDashboardComponent} from "./demo-dashboard.component";
import {DemoDashboardRoutingModule} from "./demo-dashboard-routing.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        SharedModule,
        AgGridModule,
        DemoDashboardRoutingModule,
        LiftBySpotTileModule,
        TrafficByAffiliateTileModule,
        TrafficBySourceTileModule,
        MicromomentTimelineTileModule,
        TimeOfDayTileModule,
        KwTileModule,
        MatNativeDateModule,
        LiftBySpotFullModule,
    ],
    declarations: [DemoDashboardComponent],
    exports: [DemoDashboardComponent],
    providers: []
})
export class DemoDashboardModule {}